import { render } from "./PieLegendConfiger.vue?vue&type=template&id=485d8430&scoped=true"
import script from "./PieLegendConfiger.vue?vue&type=script&lang=js"
export * from "./PieLegendConfiger.vue?vue&type=script&lang=js"

import "./PieLegendConfiger.vue?vue&type=style&index=0&id=485d8430&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bigdatadisplaysystem_php_master/front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-485d8430"]])

export default __exports__